<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {};
  },
  components: {},
  created() {
    // console.log('=====>') 
  },
};
</script>

<style lang="scss" scoped>

</style>